// extracted by mini-css-extract-plugin
export default {"row":"SocialLinks_row__bG43K","item":"SocialLinks_item__nwi48"};